import { ChainId } from '../../utils/config/networks';
export var WrappedNativeTokens = new Map([
    [1, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    [ChainId.ARBITRUM, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1'],
    [ChainId.AVALANCHE, '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7'],
    [ChainId.BSC, '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'],
    [ChainId.BASE, '0x4200000000000000000000000000000000000006'],
    [ChainId.OPTIMISM, '0x4200000000000000000000000000000000000006'],
    [ChainId.POLYGON, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270'],
    [ChainId.BLAST, '0x4300000000000000000000000000000000000004'],
]);
